

const Image = ({ cover_image_url }) => {
    return <img src={cover_image_url} alt="" />

}
export default Image;